import { Facebook, Send, Mail, MapPin } from 'lucide-react';
import { SITE } from '../mock';

const Footer = () => {
  return (
    <footer className="mt-20 border-t border-white/5 bg-[#070f21]">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <img src={SITE.logo} alt={SITE.name} className="h-12 w-12 object-contain" />
            <span className="font-bold text-lg bg-gradient-to-r from-amber-200 to-yellow-400 bg-clip-text text-transparent">
              {SITE.name}
            </span>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">
            The trusted marketplace for Free Fire accounts. Verified sellers, safe delivery, and 24/7 support via Telegram.
          </p>
        </div>

        <div>
          <h4 className="font-semibold mb-4 text-white">Marketplace</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li className="hover:text-amber-300 cursor-pointer">Free Fire Accounts</li>
            <li className="hover:text-amber-300 cursor-pointer">Top Up Diamonds</li>
            <li className="hover:text-amber-300 cursor-pointer">Boosting Service</li>
            <li className="hover:text-amber-300 cursor-pointer">Hourly Coaching</li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold mb-4 text-white">Support</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li className="hover:text-amber-300 cursor-pointer">How to Buy</li>
            <li className="hover:text-amber-300 cursor-pointer">Terms & Conditions</li>
            <li className="hover:text-amber-300 cursor-pointer">Privacy Policy</li>
            <li className="hover:text-amber-300 cursor-pointer">Contact Us</li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold mb-4 text-white">Contact</h4>
          <div className="space-y-3 text-sm text-slate-400">
            <a href={SITE.telegram} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-sky-400">
              <Send className="h-4 w-4" /> Telegram
            </a>
            <a href={SITE.facebook} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-blue-400">
              <Facebook className="h-4 w-4" /> Facebook Page
            </a>
            <div className="flex items-center gap-2">
              <Mail className="h-4 w-4" /> support@nagisa.gg
            </div>
            <div className="flex items-center gap-2">
              <MapPin className="h-4 w-4" /> Global — Online 24/7
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5 py-5 text-center text-xs text-slate-500 flex flex-wrap items-center justify-center gap-3">
        <span>© {new Date().getFullYear()} {SITE.name}. All rights reserved.</span>
        <span className="text-slate-700">|</span>
        <a href="/admin/login" className="hover:text-amber-300">Admin</a>
      </div>
    </footer>
  );
};

export default Footer;
